var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttGlobe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 38,
    height: 38,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(0 0.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(0 -0.081)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M7.328,33.909a18.935,18.935,0,0,0,24.1-.715c.04-.035.02-.06-.019-.035-1.495,1-5.754,3.178-12.461,3.178-5.829,0-9.512-1.3-11.592-2.462-.04-.02-.055.01-.025.035m12.9.968c4.662,0,9.785-1.271,12.848-3.788a10.224,10.224,0,0,0,2.353-2.825A18.053,18.053,0,0,0,36.574,25.9c.015-.039-.01-.059-.039-.015-2.85,4.2-11.1,6.812-19.62,6.812-6.022,0-12.5-1.926-15.038-5.605-.025-.035-.05-.02-.035.02,2.363,5.024,9.532,7.77,18.389,7.77m-5.094-8.335c-9.7,0-14.269-4.518-15.1-7.6-.01-.045-.04-.034-.04,0a18.8,18.8,0,0,0,.283,3.267,3.8,3.8,0,0,0,.953,1.653c2.348,2.448,8.2,5.878,18.339,5.878,13.812,0,16.969-4.6,17.614-6.116a13.857,13.857,0,0,0,.7-4.682c0-.4-.01-.715-.025-1.028,0-.049-.029-.054-.039,0-.69,3.7-12.491,8.629-22.688,8.629M1.827,10.818A18.817,18.817,0,0,0,.472,14.745a1.257,1.257,0,0,0,.1.918c1.162,2.468,7.04,6.415,20.752,6.415,8.365,0,14.864-2.055,15.917-5.808a4.455,4.455,0,0,0-.045-2.4,18.288,18.288,0,0,0-1.241-3.277c-.015-.029-.04-.025-.035.01.164,4.92-13.553,8.092-20.474,8.092-7.5,0-13.752-2.989-13.752-6.762a4.565,4.565,0,0,1,.169-1.1c.01-.035-.02-.04-.035-.01M31.456,4.776a.768.768,0,0,1,.119.437c0,2.1-6.439,5.828-16.691,5.828-7.531,0-8.942-2.795-8.942-4.573a3.072,3.072,0,0,1,.78-1.946c.03-.04,0-.054-.03-.025a19,19,0,0,0-2.666,2.77A2.412,2.412,0,0,0,3.416,8.42c0,3.684,9.234,6.355,17.868,6.355,9.2,0,13.305-3,13.305-5.644,0-.944-.367-1.495-1.306-2.562a22.377,22.377,0,0,0-1.8-1.817c-.03-.025-.049,0-.03.025m-2.82-2.105A18.919,18.919,0,0,0,9.12,2.75c-.854.527-1.335.948-1.335,1.49,0,1.6,3.733,3.316,10.356,3.316,6.553,0,11.637-1.882,11.637-3.694,0-.432-.377-.735-1.142-1.191",
    transform: "translate(0 0.11)",
    fill: "#009fdb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttGlobe);
export default __webpack_public_path__ + "static/media/att-globe.5afb19a73d415794d1d0cb8858a58105.svg";
export { ForwardRef as ReactComponent };